<template>
  <div class="mt-5">
    <b-row class="mt-5 mb-1">
        <h2>
          Information <span class="dbb-red">Page</span> 
        </h2>
    </b-row>

    <b-row class="my-1">
      <h3 class="dbb-red">{{dataset.projectTitle || ''}}</h3>
    </b-row>
    <b-row>
      <h3 class="dbb-red">{{ dataset.datasetTitle || ''}}</h3>
    </b-row>

    <b-row class="mt-5">
      <h3>Associated <span class="dbb-red">Publications</span></h3>
    </b-row>

    <b-row class="bg-light" v-for="(pub, pubIndex) in dataset.associatedPublications" :key="`pub-${pubIndex}`">
      <p class="my-3" style="font-size: 20px" v-html="pub"></p>
    </b-row>

    <b-row class="mt-5">
      <h3>Contributors</h3>
    </b-row>

    <b-row class="bg-light">
      <b-col class="mx-0 px-0">
        <p 
          class="my-3"
          style="font-size: 20px"
          v-for="(contribMain, contribMainIndex) in dataset.mainContributors" :key="`contrib-${contribMainIndex}`"
        > 
          {{ contribMain }}
        </p>

        <p style="font-size: 18px" v-show="dataset.additionalContributors.length>0">
          Additional Contributors: {{ dataset.additionalContributors.join(", ")}}
        </p>

        <h5 v-show="dataset.acknowledgements !== ''" class="mt-5">Acknowledgements</h5>
        <p class="mt-2" style="font-size: 18px">
          {{ dataset.acknowledgements }}
        </p>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <h3>How to cite</h3>
    </b-row>
    <b-row class="bg-light">
      <b-col class="mx-0 px-0">
        <p 
          class="my-3"
          style="font-size: 20px"
          v-for="(citation, citeIndex) in dataset.citationInstructions" :key="`cite-${citeIndex}`"
          v-html="citation"
        > 
        </p>
      </b-col>
    </b-row>



  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
  },
  name: "InfoPage",
  data() {
    return {
      dataset: {}
    };
  },
  
  mounted() {
    this.getDatasets()
  },
  methods: {
    getDatasets() {
     axios.get('/DigitalBrainBank/datasets', {
        params: {
          id: this.$route.params.id
        }
      })
      .then((response) => {
        if ('success' in response.data){
          this.dataset = response.data.success
        } else {
          console.log(response.data)
        }
      }, (error) => {
        console.log(error)
      }) 
    }
    
  },
  created() {},
};
</script>

<style scoped>
.dbb-red {
  color: #8b2a34;
}
</style>
